"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "scaletta-zanclea": {
    "598e652d": [{
      "hkey": "82fcb6d3",
      "slug": "guidomandri-marina-scaletta-marina",
      "name": "Guidomandri Marina-Scaletta Marina",
      "primary": true,
      "skipSearch": false
    }],
    "guidomandri-marina": [{
      "hkey": "82fcb6d3",
      "slug": "guidomandri-marina-scaletta-marina",
      "name": "Guidomandri Marina-Scaletta Marina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "97d6045a": [{
      "hkey": "82fcb6d3",
      "slug": "guidomandri-marina-scaletta-marina",
      "name": "Guidomandri Marina-Scaletta Marina",
      "primary": true,
      "skipSearch": false
    }],
    "scaletta-marina": [{
      "hkey": "82fcb6d3",
      "slug": "guidomandri-marina-scaletta-marina",
      "name": "Guidomandri Marina-Scaletta Marina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "scaletta-zanclea"
    }]
  }
};
exports["default"] = _default;